/* ============================================================
   TRIPS B GLOVES — THEME JS
   Dark/light toggle, mobile nav, scroll reveals, hero scroll
   transformation, cart helper, toast notifications
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Theme toggle ---------- */
  function initThemeToggle() {
    var root = document.documentElement;
    var toggles = document.querySelectorAll('[data-theme-toggle]');

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isDark = root.getAttribute('data-theme') === 'dark';
        var next = isDark ? 'light' : 'dark';
        if (next === 'dark') {
          root.setAttribute('data-theme', 'dark');
        } else {
          root.removeAttribute('data-theme');
        }
        localStorage.setItem('tripsb-theme', next);
        btn.setAttribute('aria-pressed', String(next === 'dark'));
      });
    });
  }

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-site-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- Scroll reveals ---------- */
  function initReveals() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Hero scroll transformation ----------
     Cross-fades the plain white glove into the fully
     customized glove as the user scrolls through the hero. */
  function initHeroTransform() {
    var hero = document.querySelector('[data-hero-transform]');
    if (!hero) return;

    var customized = hero.querySelector('[data-glove-customized]');
    if (!customized) return;

    var ticking = false;

    function update() {
      var rect = hero.getBoundingClientRect();
      var total = rect.height - window.innerHeight * 0.4;
      var scrolled = Math.min(Math.max(-rect.top, 0), total);
      var progress = total > 0 ? scrolled / total : 0;
      customized.style.opacity = progress.toFixed(3);
      hero.style.setProperty('--hero-progress', progress.toFixed(3));
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  /* ---------- Cart ---------- */
  function addToCart(variantId, quantity, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity || 1, properties: properties || {} }]
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error ' + res.status);
        return res.json();
      })
      .then(function (data) {
        showToast('Added to cart', 'success');
        updateCartCount();
        return data;
      })
      .catch(function (err) {
        showToast('Could not add to cart. Try again.', 'error');
        throw err;
      });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }

  /* ---------- Toast ---------- */
  function showToast(message, type) {
    var existing = document.querySelector('.tb-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'tb-toast tb-toast--' + (type || 'success');
    toast.setAttribute('role', 'status');
    toast.textContent = message;
    document.body.appendChild(toast);

    setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transition = 'opacity 280ms ease';
      setTimeout(function () { toast.remove(); }, 300);
    }, 3000);
  }

  /* ---------- Loading overlay (rainbow B) ----------
     Shows ONLY on the path into the Kickflip builder:
     links carrying customize=1, and the product-page arrival
     while the Kickflip modal opens. Minimum display time is a
     theme setting so the animation gets its moment. */
  var loadingShownAt = 0;

  function loadingMinMs() {
    var overlay = document.querySelector('[data-loading-overlay]');
    var s = overlay ? parseFloat(overlay.getAttribute('data-min-seconds')) : 2.5;
    return (isNaN(s) ? 2.5 : s) * 1000;
  }

  function showLoading(label) {
    var overlay = document.querySelector('[data-loading-overlay]');
    if (!overlay) return;
    if (label) {
      var text = overlay.querySelector('[data-loading-label]');
      if (text) text.textContent = label;
    }
    loadingShownAt = Date.now();
    overlay.hidden = false;
    /* Open as a modal dialog so it enters the browser's top layer and
       renders above Kickflip's modal (z-index 2147483647) */
    if (typeof overlay.showModal === 'function' && !overlay.open) {
      try { overlay.showModal(); } catch (e) { /* fall back to z-index */ }
    }
    requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
  }

  function closeLoading(overlay) {
    overlay.classList.remove('is-visible');
    setTimeout(function () {
      if (typeof overlay.close === 'function' && overlay.open) {
        try { overlay.close(); } catch (e) {}
      }
      overlay.hidden = true;
    }, 300);
  }

  function hideLoading() {
    var overlay = document.querySelector('[data-loading-overlay]');
    if (!overlay) return;
    /* Respect the minimum display time before fading out */
    var elapsed = Date.now() - loadingShownAt;
    var wait = Math.max(0, loadingMinMs() - elapsed);
    setTimeout(function () { closeLoading(overlay); }, wait);
  }

  function initLoadingOverlay() {
    /* Warm the mask image immediately. A CSS mask whose image hasn't
       downloaded yet renders the element empty — that's why the B was
       missing on the very first open. Belt-and-suspenders alongside
       the <link rel="preload"> in the head. */
    var logoEl = document.querySelector('.tb-loading__logo--masked');
    if (logoEl) {
      var raw = logoEl.style.getPropertyValue('--loading-mask') || '';
      var match = raw.match(/url\(['"]?([^'")]+)['"]?\)/);
      if (match && match[1]) {
        var warm = new Image();
        warm.decoding = 'async';
        warm.src = match[1];
      }
    }

    /* Only links that lead into the Kickflip builder */
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (href.indexOf('customize=1') !== -1) {
        showLoading();
      }
    });

    /* Arriving on a product page that will auto-open Kickflip:
       keep the overlay up until the builder actually opens. */
    if (window.location.search.indexOf('customize=1') !== -1) {
      showLoading();
      document.addEventListener('tb:kickflip-opened', function () {
        hideLoading();
      });
      /* Safety: never trap the user */
      setTimeout(hideLoading, 12000);
    }

    /* Back/forward cache: never resurrect a stale overlay */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        var overlay = document.querySelector('[data-loading-overlay]');
        if (overlay) {
          overlay.classList.remove('is-visible');
          if (typeof overlay.close === 'function' && overlay.open) {
            try { overlay.close(); } catch (err) {}
          }
          overlay.hidden = true;
        }
      }
    });

    /* A modal dialog can be dismissed with Esc — keep our state in sync */
    var ov = document.querySelector('[data-loading-overlay]');
    if (ov) {
      ov.addEventListener('close', function () {
        ov.classList.remove('is-visible');
        ov.hidden = true;
      });
    }
  }

  /* ---------- Boot ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initThemeToggle();
    initMobileNav();
    initReveals();
    initHeroTransform();
    initLoadingOverlay();
  });

  /* Public API */
  window.TripsB = {
    addToCart: addToCart,
    showToast: showToast,
    updateCartCount: updateCartCount,
    showLoading: showLoading,
    hideLoading: hideLoading
  };
})();
